export default __webpack_public_path__ + "static/scissors-d784ae7ac2153329015ffce6e7867fe0.png";